import Vue from 'vue';

export default class AppError {
    constructor(){
        this.data = Vue.observable({
            code:200,
            msg:'',
        });
    }

    code() {
        return this.data.code;
    }

    msg() {
        return this.data.msg;
    }

    isError() {
        return this.data.code !== 200;
    }

    reset() {
        this.data = {
            code:200,
            msg:'',
        };
    }

    set(code, msg) {
        this.data.code = code;
        this.data.msg = msg;
    }
}
